import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './style/index.css';
import "bootstrap/dist/css/bootstrap.css";


ReactDOM.render(
  <App />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js